import React, { useEffect, useState } from "react";
import { api, fileUrl } from "../../lib/api";
import { toast } from "sonner";
import { Trash2, ChevronDown, ChevronUp } from "lucide-react";

const STATUSES = ["ny", "vurderes", "tilbud sendt", "kjøpt", "avvist"];
const STATUS_STYLE = {
  ny: "bg-warm/20 text-navy", vurderes: "bg-electric/10 text-electric",
  "tilbud sendt": "bg-blue-100 text-blue-700", "kjøpt": "bg-green-100 text-green-700", avvist: "bg-red-100 text-red-700",
};

export default function SellRequests() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => { api.get("/admin/sell-requests").then((r) => setRows(r.data)).catch(() => {}); }, []);

  const setStatus = async (id, status) => {
    await api.put(`/admin/sell-requests/${id}/status`, { status });
    setRows((rs) => rs.map((r) => (r.id === id ? { ...r, status } : r)));
    toast.success("Status oppdatert");
  };
  const remove = async (id) => {
    if (!window.confirm("Slette denne forespørselen?")) return;
    await api.delete(`/admin/sell-requests/${id}`);
    setRows((rs) => rs.filter((r) => r.id !== id));
    toast.success("Slettet");
  };

  return (
    <div data-testid="admin-sell-requests">
      <h1 className="font-heading text-2xl font-bold text-navy">Kunder som vil selge</h1>
      <p className="mt-1 text-sm text-ink/60">Salgs-/innbytteforespørsler fra «Selg enheten din» · {rows.length} totalt</p>
      <div className="mt-6 space-y-3">
        {rows.length === 0 && <p className="text-ink/50 text-sm">Ingen forespørsler ennå.</p>}
        {rows.map((r) => (
          <div key={r.id} className="rounded-xl border border-hairline bg-white shadow-sm" data-testid={`sell-row-${r.id}`}>
            <div className="flex items-center justify-between gap-3 p-4 cursor-pointer" onClick={() => setOpen(open === r.id ? null : r.id)}>
              <div className="min-w-0">
                <p className="font-semibold text-navy truncate">{r.name} · {r.category} {r.model}</p>
                <p className="text-sm text-ink/60 truncate">{r.condition} · {new Date(r.created_at).toLocaleString("nb-NO")}</p>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className={`rounded-full px-2.5 py-1 text-xs font-medium ${STATUS_STYLE[r.status] || "bg-slate-100"}`}>{r.status}</span>
                {open === r.id ? <ChevronUp className="h-4 w-4 text-ink/40" /> : <ChevronDown className="h-4 w-4 text-ink/40" />}
              </div>
            </div>
            {open === r.id && (
              <div className="border-t border-hairline p-4 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
                {[["Telefon", r.phone], ["E-post", r.email], ["Merke", r.brand || "–"], ["Lagring", r.storage || "–"], ["Batteri", r.battery_condition || "–"], ["Alt fungerer", r.everything_works], ["Fri for låser", r.free_of_locks], ["Beskrivelse", r.description || "–"]].map(([k, v]) => (
                  <div key={k}><span className="text-ink/50">{k}: </span><span className="font-medium text-navy">{v}</span></div>
                ))}
                {r.image_id && <div className="sm:col-span-2"><img src={fileUrl(r.image_id)} alt="Enhet" className="h-28 rounded-lg border border-hairline object-cover" /></div>}
                <div className="sm:col-span-2 mt-2 flex flex-wrap items-center gap-2">
                  <span className="text-ink/50">Status:</span>
                  {STATUSES.map((s) => (
                    <button key={s} onClick={() => setStatus(r.id, s)} className={`rounded-full px-3 py-1 text-xs font-medium border ${r.status === s ? "border-electric bg-electric text-white" : "border-hairline text-navy hover:border-electric"}`} data-testid={`sell-status-${s}`}>{s}</button>
                  ))}
                  <button onClick={() => remove(r.id)} className="ml-auto inline-flex items-center gap-1 text-xs text-red-600 hover:underline" data-testid="sell-delete"><Trash2 className="h-3.5 w-3.5" /> Slett</button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
